define('webshopCategoriesDetailView',[
  'app',
  'module',
  'underscore',
  'windows',
  'headerFooterView',
  'webshopCategoriesDetailHeaderView',
  'webshopCategoriesDetailBodyView',
  'entities/webshop/webshop',
  'entities/webshop/categories'
], function (
  App,
  Module,
  _,
  Windows,
  HeaderFooterView,
  HeaderView,
  BodyView
) {
  'use strict';

  Module.exports = HeaderFooterView.extend({
    className: 'webshop-categories-detail-view ' + HeaderFooterView.prototype.className,
    childHeaderView: HeaderView,
    childView: BodyView,

    modelEvents: {
      'change:texts': function () {
        this.windowView.setTitle();
      }
    },

    initialize: function () {
      HeaderFooterView.prototype.initialize.call(this);

      this.view.on('selected', _.bind(function () {  
        Windows.setNavigation();
      }, this));      
    },    

    // Static methods
    open: function (id, tabName) {
      require([
        'windows',
        'webshopCategoriesDetailView'
      ], function (Windows, View) {                    
        App.request('webshop.config').done(_.bind(function (webshopConfig) {
          Windows.open({
            view: _.bind(function () {
              var defer = $.Deferred(); 
              var model = App.request('webshop.category.model', {id: id});
              model.fetch().done(_.bind(function () {
                defer.resolve(new View({
                  model: model,
                  webshopConfig: webshopConfig,
                  tabName: tabName
                }));
              }, this));
              return defer.promise();
            }, this),          
            navigation: _.bind(function (windowView, view) {
              var defer = $.Deferred(); 
              if(view) {
                var uri = 'webshop/categories/' + view.model.get('id');
                var tab = view.view.getSelected();
                if (tab && tab.get('url') !== '')
                    uri += '/' + tab.get('url');
                defer.resolve(uri);
              }
              return defer.promise();
            }, this),                     
            id: 'webshop.category:' + id,
            title: _.bind(function (windowView, view) {
              return _.i18n('webshop.category.title') + ' | ' + view.model.getName();
            }, this),            
            width: '80%',
            height: '80%'
          });         
        }, this));
      });
    }
  });
});

